export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-02.jpg'),
        title: 'BUSINESS PROCESS',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'THE BACKBONE OF EVERY WELL-FUNCTIONING COMPANY. ',
      description: `<p style="font-size:1.5rem">Your business process stands at the base of your organizational goal. A smooth, efficient and highly organized
business process is key to achieving your goals. All your business activities are vital to the good operation
of your company and all of them are based on the same blueprint: the business process.
 In that sense, a well organized, streamlined business process is the
backbone of every well-functioning company. </p><p>We have a great breadth and depth of experience that we will use to analyze your current business process, optimize your workflows,
eliminate any inefficiencies and improve each step of your business process. Streamlining your business processes is one of our core
objectives and part of our Business Planning Approach. Here at MaesInfo we will put our extensive experience and competencies
to use in order to help our clients improve work efficiency and reduce operation costs.</p>`
    },
    {
      title: 'MAESINFO WILL BRING LASTING BENEFITS TO YOUR COMPANY BY:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-02.jpg')+`)"></span>
      <span>researching and analyzing the processes and systems that your business
implements.
making recommendations to optimize and improve these processes and
practices
improving efficiency (e.g. finding and eliminating bottlenecks in your business
process, inefficient use of resources, finding and eliminating unnecessary
processes, reducing the amount of errors that lead to parts of the process
being redone, improving communication)
compiling a detailed report that highlights all areas that need improving, and
assisting in optimizing your business process.
</span>`
    }
  ]
}
